"use client";

import { useEffect } from "react";
import { useSessionStartChooser } from "@/contexts/session-start-chooser";

interface UseAllTeamsGalleryChooserRegistrationInput {
  openAllTeamsGallery: () => void;
}

/**
 * Lend the landing's "All teams" opener to the session-start chooser for as
 * long as the landing is mounted. The chooser host renders beside the route
 * subtree rather than inside it, so this registration is its ONLY way to the
 * gallery the hero CTA opens — without it the chooser would need a second
 * mechanism for the same surface.
 *
 * Taken back on unmount, so a chooser raised from a session screen finds no
 * opener and takes the navigating branch instead.
 */
export function useAllTeamsGalleryChooserRegistration({
  openAllTeamsGallery,
}: UseAllTeamsGalleryChooserRegistrationInput): void {
  const { setOpenAllTeamsGallery } = useSessionStartChooser();

  useEffect(() => {
    setOpenAllTeamsGallery(openAllTeamsGallery);
    return () => {
      setOpenAllTeamsGallery(null);
    };
  }, [openAllTeamsGallery, setOpenAllTeamsGallery]);
}
